import { makeDeviceKeys } from './keys.ts';

// This device's key pair for end-to-end credentials (docs/specs/secrets.md SE-12), kept in the app's
// IndexedDB as Web Crypto keys: the private half is stored as it is, not extractable, so the page
// can use it but nothing can read it out (QSE-5: IndexedDB first; the OS vault where a shell's
// IndexedDB turns out not to keep it).

const DATABASE = 'casa-keys';
const STORE = 'keys';
const DEVICE = 'device';

function request<T>(pending: IDBRequest<T>) : Promise<T> {
    return new Promise((resolve, reject) => {
        pending.onsuccess = () => resolve(pending.result);
        pending.onerror = () => reject(pending.error ?? new Error('IndexedDB failed'));
    });
}

async function openDatabase() : Promise<IDBDatabase> {
    const opening = indexedDB.open(DATABASE, 1);

    opening.onupgradeneeded = () => opening.result.createObjectStore(STORE);

    return request(opening);
}

/** This device's keys: those kept, or new ones, kept from now on. */
export async function deviceKeys() : Promise<CryptoKeyPair> {
    const database = await openDatabase();

    try {
        const kept = (await request(database.transaction(STORE, 'readonly').objectStore(STORE).get(DEVICE))) as CryptoKeyPair | undefined;

        if (kept) {
            return kept;
        }

        const made = await makeDeviceKeys();

        await request(database.transaction(STORE, 'readwrite').objectStore(STORE).put(made, DEVICE));

        return made;
    } finally {
        database.close();
    }
}
